import FormattedMessage from 'I18n/components/FormattedMessage';
import { getProductNameTextFromApiName } from '../../_core/common/adapters/getProductNameText';
import UIPricingPageRedirectButton from '../../button/UIPricingPageRedirectButton';
// @ts-expect-error dependency missing types
import UpgradeProductToApiNameMap from 'self-service-api/constants/UpgradeProductToApiNameMap';
import { CRM_SUITE_STARTER_BUNDLE } from 'self-service-api/constants/ApiNames';
import { SUITE_STARTER } from 'self-service-api/constants/UpgradeProducts';
import { getUpgradeButtonTextFromApiName } from '../../_core/common/adapters/getUpgradeButtonText';
import { getBannerI18nTitleKey } from '../utils';
import DefaultBanner from './DefaultBanner';
import { useUpgradeDataFromUpgradeConfig } from './useUpgradeDataFromUpgradConfig';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RemoveBrandingBanner = ({
  upgradePoint,
  className,
  style,
  'data-test-id': dataTestId = 'locked-feature-banner',
  isFreePortal = false,
  isUngatedUpgradeBannerRedesign2024
}) => {
  const upgradeData = useUpgradeDataFromUpgradeConfig(upgradePoint);
  const apiNameToUse = upgradeData.apiName || UpgradeProductToApiNameMap[upgradeData.upgradeProduct];
  return /*#__PURE__*/_jsx(DefaultBanner, {
    className: className,
    dataTestId: dataTestId,
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: getBannerI18nTitleKey('upgrades.removeBrandingBanner.titles', upgradePoint.featureTranslationKey)
    }),
    subtext: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.lockedFeatureBanner.text"
      }), "\xA0", /*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.message.productName",
        options: {
          productName: getProductNameTextFromApiName(apiNameToUse)
        }
      })]
    }),
    button: isUngatedUpgradeBannerRedesign2024 ? /*#__PURE__*/_jsx(UIPricingPageRedirectButton, {
      upgradeData: upgradeData,
      use: "link",
      isUpgradePoint: true,
      style: {
        padding: '0px'
      },
      goToUpgradePage: isFreePortal && (upgradeData.apiName === CRM_SUITE_STARTER_BUNDLE || upgradeData.upgradeProduct === SUITE_STARTER),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.upgradeButton.default"
      })
    }) : /*#__PURE__*/_jsx(UIPricingPageRedirectButton, {
      upgradeData: upgradeData,
      use: "tertiary-light",
      isUpgradePoint: true,
      goToUpgradePage: isFreePortal && (upgradeData.apiName === CRM_SUITE_STARTER_BUNDLE || upgradeData.upgradeProduct === SUITE_STARTER),
      children: getUpgradeButtonTextFromApiName('default', apiNameToUse)
    }),
    style: style,
    isUngatedUpgradeBannerRedesign2024: isUngatedUpgradeBannerRedesign2024
  });
};
export default RemoveBrandingBanner;